export default __webpack_public_path__ + "static/media/timer-alert.9791d9ac.svg";